<template>
<div id="sendEmail">
    <div class="icon-util" style="float:left" @click="sendEmailClose()" :class="[sendShow?'check-small':'nocheck-small-blue']"></div>
    <span class="check-item-position"  @click="sendEmailClose()">{{$t('language.popup.sendEmail')}}</span>
    <div class="send-email-body" :class="sendShow?'':'check-none'">
        <div class="send-email-item" :class="shakeBox">
            <input class="send-email" :placeholder="$t('language.twoStepverification.enterEmail')" v-model='email' />
        </div>
        <button class="send-letter" @click="sendEmail()">{{$t('language.popup.sendMessage')}}</button>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import commonstate from '@/js/constant.js';
export default {
    data: function () {
        return {
            sendShow: false,
            email: "",
            shakeBox: ""
        }
    },
    methods: {
        sendEmail() {
            if (this.email) {
                if (!commonstate.emailpattern.test(this.email)) {
                    this.$toast({
                        text: this.$t('language.login.enterCorrectEmai'),
                        type: 'fail',
                        idValue: "sendEmail"
                    });
                    return false;
                }
                let emailData = {
                    email: this.email,
                    ud: commonUtils.getUser().id
                }
                this.Utils.doEmailRequest("send_test_msg", emailData).then(res => {
                    if (res.status == 200) {
                        this.$toast({
                            text: this.$t('language.meassage.emailSend'),
                            type: 'success',
                            idValue: "rightContBan"
                        });
                    } else {
                        this.$toast({
                            text: this.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: "sendEmail"
                        });
                    }
                });
            } else {
                this.shakeBox = "email-shake";
                setTimeout(() => {
                    this.shakeBox = "box-shakeOrigin";
                }, 200);
            }
        },
        sendEmailClose() {
            this.sendShow = !this.sendShow;
            if (!this.sendShow) {
                this.email = "";
            } else {
                this.email = commonUtils.getUser().email;
            }
        }
    }

};
</script>

<style>
.send-email {
    width: 400px;
    /*no*/
    height: 30px;
    /*no*/
    float: left;
    margin-top: 10px;
    /*no*/
    padding-left: 31px;
    /*no*/
    border-color: #4181FF;
}

.send-email-body {
    position: relative;
    display: flex;
}

.send-email-item::before {
    content: '';
    position: absolute;
    width: 16px;/*no*/
    height: 16px;/*no*/
    background: url("../../../../assets/images/vectorImg/icon_email_grow.svg") no-repeat;
    left: 10px;/*no*/
    bottom: 7px;/*no*/
}

.send-letter {
    height: 30px;
    /*no*/
    float: left;
    margin-top: 10px;
    /*no*/
    margin-left: 18px;
    /*no*/
    line-height: 15px;
    /*no*/
}

.check-none {
    pointer-events: none;
    opacity: 0.2;
}

</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_options/tab_email.vue